import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, Skeleton } from '@mui/material';
import Typography from '@digital-hig/typography';
import DOMPurify from 'isomorphic-dompurify';
import { useTranslation } from 'react-i18next';

const StoriesSection = ({ title, content, loading }) => {
  const { t } = useTranslation();
  const { t: translate } = useTranslation('success_story');
  return (
    <Box className="story-section">
      <Box className="story-page-container">
        <Typography variant="headline-large" mb={7} component="h2">
          {t(title)}
          {/* {(loading) && <Skeleton animation="pulse" variant="text" width="50%" />} */}
        </Typography>
        {content && (
          <Box
            variant="body-copy-medium"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(translate(content)) }}
          />
        )}
        {(loading && !content) && [...Array(4).keys()].map((e) => <Skeleton key={`story-section-shimmer-${title}-${e}`} animation="pulse" variant="text" />)}
      </Box>
    </Box>
  );
};
StoriesSection.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  loading: PropTypes.bool,
};
StoriesSection.defaultProps = {
  title: '',
  content: '',
  loading: false,
};
export default StoriesSection;
